define.alias("ember-drag-sort/components/drag-sort-list", "preview-grid/components/drag-sort-list");